import React from 'react'
import {Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import Tr from 'translations/Translations';
import SingleButton from "../components/SingleButton";

function Alert(
    {
        title = 'attention',
        open,
        confirmText,
        confirmText2,
        maxWidth= 'xs',
        onClose,
        buttonText = Tr('close'),
        translateTexts = false
    }) {

    return (
        <Dialog
            title={Tr(title)}
            open={open}
            titleCentered
            maxWidth={maxWidth}
            onClose={onClose}
            dialogActions={<SingleButton
                justify='flex-end'
                label={buttonText}
                onClick={onClose}
            />}
        >
            {!!confirmText && <Typography variant='body1'>
                {translateTexts ? Tr(confirmText) : confirmText}
            </Typography>}
            {!!confirmText2 && <Typography variant='body1'>
                {translateTexts ? Tr(confirmText2) : confirmText2}
            </Typography>}

        </Dialog>
    )
}

Alert.propTypes = {
    classes: PropTypes.any,
    open: PropTypes.bool.isRequired,
    confirmText: PropTypes.string.isRequired,
    confirmText2: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    buttonText: PropTypes.string,
    translateTexts: PropTypes.bool
}

export default Alert;